<template>
  <div class="capture">
    <input
      type="text"
      :value="value"
      :placeholder="$t('visitor.apply.sms.tips')"
      class="input"
      v-on:input="$emit('input', $event.target.value)"
    />
    <div class="auth disabled" v-if="send">
      {{ count + $t('visitor.apply.sms.count.tips') }}
    </div>
    <div class="auth" @click="sendSMS" v-else>
      {{ $t('visitor.apply.getsms') }}
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { Notify, Toast } from 'vant';
export default {
  props: ['value', 'phone'],
  data() {
    return {
      count: 60,
    };
  },
  computed: {
    send() {
      return this.count < 60;
    },
    phoneValue() {
      return this.phone;
    },
  },
  methods: {
    sendSMS() {
      if (!this.phoneValue) {
        return Notify({
          type: 'warning',
          message: this.$t('visitor.apply.phone.tips'),
        });
      }
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('empty.loading') + '...',
      });
      api
        .sendSMS({
          phone: this.phoneValue,
        })
        .then(res => {
          Toast.clear();
          if (res) {
            Notify({
              type: 'success',
              message: this.$t('visitor.apply.sms.success.tips'),
            });
            this.countDown();
          }
        });
    },
    countDown() {
      this.count--;
      if (this.count > 0) {
        setTimeout(this.countDown, 1000);
      } else {
        this.count = 60;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.capture {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
  .input {
    width: calc(100% - 180px);
    border: none;
    font-size: 30px;
    padding: 6px 0;
    line-height: 34px;

    color: #3d424d;

    &::placeholder {
      color: #949aa4;
    }
  }
  .auth {
    width: 180px;
    border-left: solid 1px #d4d6d9;
    height: 30px;
    font-size: 30px;
    line-height: 33px;
    color: #00ccbf;
    text-align: right;
    user-select: none;

    &.disabled {
      color: #949aa4;
    }
  }
}
</style>
